import React, { ReactNode, JSX } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'reactstrap';
import { observer } from 'mobx-react';
import fallback from '../../../_Translations/generated/packageBox.en.t.json';
import Keys from '../../../_Translations/generated/packageBox.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';

export interface Props {
  header?: ReactNode;
  content?: ReactNode;
  isIncluded?: boolean;
  onRemoveComponent?: () => void;
}

const PackageBox = observer(
  (props: Props): JSX.Element => {
    const { content, header, isIncluded = true, onRemoveComponent } = props;
    const { t } = useTranslation('packageBox', fallback, Keys);

    return (
      <Card className="package-box package-box__height">
        {header && <div className="package-box__wrapper__slider">{header}</div>}
        <div
          className={
            isIncluded
              ? 'package-box__wrapper__description package-box__wrapper__description--included'
              : 'package-box__wrapper__description package-box__wrapper__description--additional'
          }
        >
          {isIncluded ? t(Keys.inclusive) : t(Keys.additional)}
        </div>
        {!isIncluded && onRemoveComponent && (
          <button
            type="button"
            className="package-box__remove btn btn-primary"
            onClick={onRemoveComponent}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
        <div className="package-box__content p-2">{content}</div>
      </Card>
    );
  }
);

export default PackageBox;
